export interface MetaData {
    title: string;
    description: string;
    keywords: string;
}

export const defaultGuestMeta: MetaData = {
    title: "Prime Shark | Global Business Network",
    description:
        "Connect with entrepreneurs, investors, buyers, mentors, and business professionals worldwide through Prime Shark.",
    keywords:
        "Prime Shark, business network, entrepreneurs, investors, startup funding, venture capital, angel investors, business buyers, business networking, global business, startup ecosystem, strategic partnerships",
};

export const defaultLoggedInMeta: MetaData = {
    title: "Prime Shark Dashboard",
    description:
        "Manage your business opportunities, funding, networking, partnerships, and growth from your Prime Shark dashboard.",
    keywords:
        "Prime Shark dashboard, entrepreneur dashboard, investor dashboard, business networking, startup funding, investment opportunities, business growth, strategic partnerships",
};

export const metadata = {
    entrepreneur: {
        title: "Prime Shark for Entrepreneurs | Funding & Business Growth",
        description:
            "Access global funding opportunities, connect with verified investors, find business buyers, and build strategic partnerships through Prime Shark.",
        keywords:
            "Prime Shark entrepreneurs, startup funding, business funding, entrepreneurs, verified investors, angel investors, venture capital, business buyers, strategic partnerships, startup growth, business networking, capital raising",
    },
    register: {
        capitalBridge: {
            title: "Capital Bridge | Connect with Verified Global Investors",
            description:
                "Connect with verified angel investors, venture capital firms, and global funding partners. Raise capital for your startup through Prime Shark's Capital Bridge.",
            keywords:
                "Capital Bridge, Prime Shark, angel investors, venture capital, startup funding, investors, funding platform, seed funding, Series A funding, business investment, capital raising, global investors",
        },

        businessExchange: {
            title: "Business Exchange | Find Buyers & Strategic Partners",
            description:
                "Find qualified buyers & sellers or connect with strategic partners through Prime Shark's trusted global business exchange platform.",
            keywords:
                "Business Exchange, Prime Shark, business buyers, business sellers, buy a business, sell a business, mergers and acquisitions, M&A, strategic partnerships, business acquisition, business marketplace",
        },

        globalConnect: {
            title: "Global Connect | Expand Your Business Network Worldwide",
            description:
                "Build valuable business relationships with entrepreneurs, investors, mentors, and industry experts worldwide through Prime Shark's Global Connect.",
            keywords:
                "Global Connect, Prime Shark, business networking, entrepreneurs, investors, mentors, business community, professional networking, global business network, startup ecosystem, industry experts",
        },

        investor: {
            title: "Prime Shark for Investors | Discover Verified Startup Investment Opportunities",
            description:
                "Explore verified startups, discover curated investment opportunities, connect with promising entrepreneurs, and grow your investment portfolio with Prime Shark.",
            keywords:
                "Prime Shark investors, startup investment, verified startups, investment opportunities, angel investing, venture capital, startup portfolio, entrepreneurs, private equity, business investment platform",
        },

        mentor: {
            title: "Prime Shark for Mentors | Guide Startups & Shape Innovation",
            description: "Mentor ambitious entrepreneurs, share your expertise, connect with innovative startups, and help businesses grow through Prime Shark's global mentor network.",
            keywords: "Prime Shark, startup mentor, business mentor, entrepreneur mentor, startup coaching, business advisor, startup ecosystem, mentor network, innovation, founders, business leadership, entrepreneurship"
        }
    },
    login: {
        capitalBridge: {
            title: "Capital Bridge Login | Prime Shark",
            description:
                "Sign in to Capital Bridge to connect with verified investors, manage funding opportunities, and access your startup fundraising dashboard.",
            keywords:
                "Capital Bridge login, Prime Shark login, investor login, startup funding, angel investors, venture capital, fundraising dashboard, capital raising, funding platform",
        },

        businessExchange: {
            title: "Business Exchange Login | Prime Shark",
            description:
                "Sign in to Business Exchange to manage your business listings, connect with qualified buyers and sellers, and explore strategic partnership opportunities.",
            keywords:
                "Business Exchange login, Prime Shark login, business buyers, business sellers, buy business, sell business, mergers and acquisitions, business marketplace, strategic partnerships",
        },

        globalConnect: {
            title: "Global Connect Login | Prime Shark",
            description:
                "Sign in to Global Connect to expand your professional network and connect with entrepreneurs, investors, mentors, and industry experts worldwide.",
            keywords:
                "Global Connect login, Prime Shark login, business networking, entrepreneur network, investor network, mentor network, professional networking, global business community",
        },

        investor: {
            title: "Investor Login | Prime Shark",
            description:
                "Sign in to your Investor account to discover verified startups, manage investment opportunities, and connect with entrepreneurs through Prime Shark.",
            keywords:
                "Investor login, Prime Shark investor, startup investment, angel investor, venture capital, investment opportunities, startup portfolio, investor dashboard",
        },

        mentor: {
            title: "Mentor Login | Prime Shark",
            description:
                "Sign in to your Mentor account to guide entrepreneurs, manage mentorship requests, share your expertise, and support startup growth through Prime Shark.",
            keywords:
                "Mentor login, Prime Shark mentor, startup mentor, business mentor, entrepreneurship, startup coaching, business advisor, mentor dashboard",
        }
    },
    dashboard: {
        capitalBridge: {
            home: {
                title: "Capital Bridge Dashboard | Prime Shark",
                description: "Access your Capital Bridge dashboard to manage funding opportunities, investor connections, proposals, and startup growth.",
                keywords: "Capital Bridge dashboard, startup funding, investors, fundraising, Prime Shark"
            },
            investors: {
                title: "Verified Investors | Capital Bridge",
                description: "Browse and connect with verified angel investors, venture capital firms, and funding partners.",
                keywords: "verified investors, venture capital, angel investors, startup funding"
            },
            globalConnect: {
                title: "Global Connect | Capital Bridge",
                description: "Expand your network by connecting with entrepreneurs, investors, mentors, and industry experts.",
                keywords: "business networking, entrepreneurs, investors, mentors"
            },
            chats: {
                title: "Investor Chats | Capital Bridge",
                description: "Communicate securely with investors and funding partners through Capital Bridge.",
                keywords: "investor chat, business messaging, startup communication"
            },
            sentProposals: {
                title: "Send Investment Proposals | Capital Bridge",
                description: "Create, send, and track investment proposals with verified investors.",
                keywords: "investment proposal, fundraising, investor proposal"
            },
            profileAnalysis: {
                title: "Profile Analysis | Capital Bridge",
                description: "Review your profile strength and optimize it to attract investors and funding opportunities.",
                keywords: "profile analysis, investor profile, startup profile"
            },
            mySubscription: {
                title: "My Subscription | Capital Bridge",
                description: "Manage your Capital Bridge subscription, membership plan, and billing details.",
                keywords: "subscription, membership, billing, Capital Bridge"
            },
            myProfile: {
                title: "My Profile | Capital Bridge",
                description: "Update your startup profile, company information, and funding preferences.",
                keywords: "startup profile, company profile, Prime Shark profile"
            }
        },

        globalConnect: {
            home: {
                title: "Global Connect Dashboard | Prime Shark",
                description: "Access your Global Connect dashboard to expand your professional network worldwide.",
                keywords: "global connect, networking dashboard, entrepreneurs, investors"
            },
            investors: {
                title: "Business Connections | Global Connect",
                description: "Discover entrepreneurs, investors, mentors, and professionals from around the world.",
                keywords: "business connections, entrepreneurs, investors, mentors"
            },
            globalConnect: {
                title: "Global Network | Global Connect",
                description: "Explore and build meaningful global business relationships.",
                keywords: "global networking, business relationships, professional network"
            },
            chats: {
                title: "Messages | Global Connect",
                description: "Chat with your professional connections securely through Global Connect.",
                keywords: "business chat, networking messages, professional communication"
            },
            sentProposals: {
                title: "Send Investment Proposals | Global Connect",
                description: "Manage and track the proposals you've shared with your business connections.",
                keywords: "business proposal, send proposals, partnerships"
            },
            profileAnalysis: {
                title: "Profile Analysis | Global Connect",
                description: "Improve your professional profile to maximize networking opportunities.",
                keywords: "profile analysis, networking profile"
            },
            mySubscription: {
                title: "My Subscription | Global Connect",
                description: "Manage your Global Connect subscription and membership details.",
                keywords: "subscription, membership, Global Connect"
            },
            myProfile: {
                title: "My Profile | Global Connect",
                description: "Manage your profile, expertise, interests, and networking preferences.",
                keywords: "profile, networking profile, professional profile"
            }
        },

        businessExchange: {
            home: {
                title: "Business Exchange Dashboard | Prime Shark",
                description: "Manage your business buying, selling, and partnership opportunities.",
                keywords: "Business Exchange dashboard, buy business, sell business"
            },
            investors: {
                title: "Business Buyers & Sellers | Business Exchange",
                description: "Connect with qualified buyers, sellers, and strategic partners worldwide.",
                keywords: "business buyers, business sellers, acquisitions"
            },
            globalConnect: {
                title: "Strategic Connections | Business Exchange",
                description: "Expand your business network and discover new partnership opportunities.",
                keywords: "strategic partnership, business networking"
            },
            chats: {
                title: "Business Chats | Business Exchange",
                description: "Communicate securely with buyers, sellers, and business partners.",
                keywords: "business messaging, buyer chat, seller chat"
            },
            sentProposals: {
                title: "Business Proposals | Business Exchange",
                description: "Create and manage proposals for buying, selling, or partnering with businesses.",
                keywords: "business proposal, acquisition proposal, partnership proposal"
            },
            profileAnalysis: {
                title: "Profile Analysis | Business Exchange",
                description: "Optimize your business profile to attract buyers and strategic partners.",
                keywords: "business profile, profile analysis"
            },
            mySubscription: {
                title: "My Subscription | Business Exchange",
                description: "Manage your Business Exchange subscription and account benefits.",
                keywords: "subscription, membership, Business Exchange"
            },
            myProfile: {
                title: "My Profile | Business Exchange",
                description: "Update your business profile, company details, and exchange preferences.",
                keywords: "business profile, company profile"
            }
        },
        investor: {
            home: {
                title: "Investor Dashboard | Prime Shark",
                description:
                    "Access your investor dashboard to discover startups, manage investment opportunities, and connect with entrepreneurs worldwide.",
                keywords:
                    "Investor Dashboard, Prime Shark, startup investment, investors, investment opportunities, entrepreneur network",
            },

            capitalBridge: {
                title: "Explore Businesses | Prime Shark",
                description:
                    "Browse verified startups, evaluate funding opportunities, and connect directly with entrepreneurs through Capital Bridge.",
                keywords:
                    "Capital Bridge, investors, startup funding, verified startups, venture capital, angel investing",
            },

            chats: {
                title: "Message Center | Prime Shark",
                description:
                    "Communicate securely with entrepreneurs, founders, and investment partners through your investor messaging center.",
                keywords:
                    "Message Center, Prime Shark, startup messaging, entrepreneur communication",
            },

            myProposals: {
                title: "My Investment Proposals | Prime Shark",
                description:
                    "Review, manage, and track your investment proposals and funding discussions with startups.",
                keywords:
                    "investment proposals, investor proposals, startup investments, funding proposals",
            },

            profileAnalysis: {
                title: "Investor Profile Analysis | Prime Shark",
                description:
                    "Analyze and improve your investor profile to increase visibility and attract high-quality startup opportunities.",
                keywords:
                    "investor profile, profile analysis, investment profile, Prime Shark",
            },

            myProfile: {
                title: "My Investor Profile | Prime Shark",
                description:
                    "Manage your investor profile, investment interests, preferred industries, and account information.",
                keywords:
                    "investor profile, account settings, investment preferences, Prime Shark",
            },

            startups: {
                title: "Discover Startups | Prime Shark",
                description:
                    "Explore verified startups across industries, review business profiles, and identify your next investment opportunity.",
                keywords:
                    "verified startups, startup discovery, startup investment, investment opportunities",
            },

            portfolioExpansion: {
                title: "Portfolio Expansion | Prime Shark",
                description:
                    "Discover new investment opportunities and diversify your portfolio with promising startups and businesses.",
                keywords:
                    "portfolio expansion, startup portfolio, investment diversification, investors",
            },

            smartInsight: {
                title: "Smart Insight | Prime Shark",
                description:
                    "Access AI-powered insights, startup analytics, and investment intelligence to make informed investment decisions.",
                keywords:
                    "AI investment insights, startup analytics, investment intelligence, smart insights",
            },

            globalOpportunities: {
                title: "Global Investment Opportunities | Prime Shark",
                description:
                    "Explore international startups, emerging markets, and global investment opportunities through Prime Shark.",
                keywords:
                    "global investment, international startups, worldwide investment opportunities, investors",
            },
        },
    },
    common: {
        investorForum: {
            title: "Investor Forum | Prime Shark",
            description:
                "Join discussions with investors, entrepreneurs, mentors, and industry experts. Share insights, ask questions, and build valuable business relationships.",
            keywords:
                "Investor Forum, startup discussions, business forum, investors, entrepreneurs, Prime Shark",
        },

        mentorConnect: {
            title: "Mentor Connect | Prime Shark",
            description:
                "Connect with experienced mentors, business leaders, and industry experts to accelerate your business and investment journey.",
            keywords:
                "Mentor Connect, business mentors, startup mentors, entrepreneurship, business coaching, Prime Shark",
        },

        paymentStatus: {
            title: "Payment Status | Prime Shark",
            description:
                "View the status and details of your Stripe payment transaction on Prime Shark.",
            keywords:
                "Payment status, stripe checkout, subscription payment, transaction reference, Prime Shark",
        },

        contactSupport: {
            title: "Contact Support | Prime Shark",
            description:
                "Get in touch with the Prime Shark support team for inquiries, assistance, and guidance.",
            keywords:
                "Contact Support, Prime Shark, support inquiries, customer support, help center",
        },
    },
} as const;

export const routeMeta: Record<string, MetaData> = {
    "/payment-status": metadata.common.paymentStatus,
    "/entrepreneur/type": metadata.entrepreneur,

    // Capital Bridge
    "/entrepreneur/investment/options": metadata.register.capitalBridge,
    "/entrepreneur/investment/register": metadata.register.capitalBridge,
    "/entrepreneur/investment/login": metadata.login.capitalBridge,
    "/entrepreneur/investment/home": metadata.dashboard.capitalBridge.home,
    "/entrepreneur/investment/investors": metadata.dashboard.capitalBridge.investors,
    "/entrepreneur/investment/global-connect": metadata.dashboard.capitalBridge.globalConnect,
    "/entrepreneur/investment/chats": metadata.dashboard.capitalBridge.chats,
    "/entrepreneur/investment/Send-proposals": metadata.dashboard.capitalBridge.sentProposals,
    "/entrepreneur/investment/profile-analysis": metadata.dashboard.capitalBridge.profileAnalysis,
    "/entrepreneur/investment/my-subscription": metadata.dashboard.capitalBridge.mySubscription,
    "/entrepreneur/investment/my-profile": metadata.dashboard.capitalBridge.myProfile,

    // Global Connect
    "/entrepreneur/want-to-grow/options": metadata.register.globalConnect,
    "/entrepreneur/want-to-grow/register": metadata.register.globalConnect,
    "/entrepreneur/want-to-grow/login": metadata.login.globalConnect,

    "/entrepreneur/want-to-grow/home": metadata.dashboard.globalConnect.home,
    "/entrepreneur/want-to-grow/investors": metadata.dashboard.globalConnect.investors,
    "/entrepreneur/want-to-grow/global-connect": metadata.dashboard.globalConnect.globalConnect,
    "/entrepreneur/want-to-grow/chats": metadata.dashboard.globalConnect.chats,
    "/entrepreneur/want-to-grow/Send-proposals": metadata.dashboard.globalConnect.sentProposals,
    "/entrepreneur/want-to-grow/profile-analysis": metadata.dashboard.globalConnect.profileAnalysis,
    "/entrepreneur/want-to-grow/my-subscription": metadata.dashboard.globalConnect.mySubscription,
    "/entrepreneur/want-to-grow/my-profile": metadata.dashboard.globalConnect.myProfile,

    // Business Exchange    
    "/entrepreneur/want-to-sell/options": metadata.register.businessExchange,
    "/entrepreneur/want-to-sell/register": metadata.register.businessExchange,
    "/entrepreneur/want-to-sell/login": metadata.login.businessExchange,

    "/entrepreneur/want-to-sell/home": metadata.dashboard.businessExchange.home,
    "/entrepreneur/want-to-sell/investors": metadata.dashboard.businessExchange.investors,
    "/entrepreneur/want-to-sell/global-connect": metadata.dashboard.businessExchange.globalConnect,
    "/entrepreneur/want-to-sell/chats": metadata.dashboard.businessExchange.chats,
    "/entrepreneur/want-to-sell/Send-proposals": metadata.dashboard.businessExchange.sentProposals,
    "/entrepreneur/want-to-sell/profile-analysis": metadata.dashboard.businessExchange.profileAnalysis,
    "/entrepreneur/want-to-sell/my-subscription": metadata.dashboard.businessExchange.mySubscription,
    "/entrepreneur/want-to-sell/my-profile": metadata.dashboard.businessExchange.myProfile,

    "/investor/options": metadata.register.investor,
    "/investor/register": metadata.register.investor,
    "/investor/login": metadata.login.investor,
    // Investor Dashboard
    "/investor/home": metadata.dashboard.investor.home,
    "/investor/capital-bridge": metadata.dashboard.investor.capitalBridge,
    "/investor/chats": metadata.dashboard.investor.chats,
    "/investor/my-proposals": metadata.dashboard.investor.myProposals,
    "/investor/profile-analysis": metadata.dashboard.investor.profileAnalysis,
    "/investor/my-profile": metadata.dashboard.investor.myProfile,
    "/investor/startups": metadata.dashboard.investor.startups,
    "/investor/portfolio-expansion": metadata.dashboard.investor.portfolioExpansion,
    "/investor/smart-insight": metadata.dashboard.investor.smartInsight,
    "/investor/global-opportunities": metadata.dashboard.investor.globalOpportunities,

    "/mentor/register": metadata.register.mentor,
    "/mentor/options": metadata.register.mentor,
    "/mentor/login": metadata.login.mentor,


    "/investor-forum": metadata.common.investorForum,
    "/mentor/mentor-connect": metadata.common.mentorConnect,
    "/guest/mentor-connect": metadata.common.mentorConnect,
    "/contact-support": metadata.common.contactSupport,
};